import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const translations = {
  en: {
    // Nav
    login: 'Login',
    getStarted: 'Get Started',
    more: 'More',
    howItWorks: 'How It Works',
    features: 'Features',
    listProperty: 'List Property',
    agentDashboard: 'Agent Dashboard',
    lawyers: 'Lawyers',
    photographers: 'Photographers',
    stylists: 'Stylists',
    heroTitle: 'AI-Powered Property Intelligence',
    heroSubtitle: 'Smarter listings, better decisions — for Australia, UAE & Bangladesh',
    searchPlaceholder: 'Search suburb, city or postcode...',
    buy: 'Buy',
    rent: 'Rent',
    sell: 'Sell',
    commercial: 'Commercial',
    offMarket: 'Off-Market',
    bangladeshTitle: 'Bangladesh Property Market',
    bangladeshSubtitle: "Explore Dhaka, Chittagong, Sylhet & Cox's Bazar with AI-powered insights",
    rajukNote: 'RAJUK Approved Developments',
    language: 'Language',
    english: 'English',
    bengali: 'বাংলা',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    apply: 'Apply',
    cancel: 'Cancel',
    save: 'Save',
    submit: 'Submit',
    back: 'Back',
    next: 'Next',
    close: 'Close',
    loading: 'Loading...',
    noResults: 'No results found',
    viewAll: 'View All',
    learnMore: 'Learn More',
    contactUs: 'Contact Us',
    home: 'Home',
    aboutUs: 'About Us',
    faq: 'FAQ',
    helpSupport: 'Help & Support',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    searchResults: 'Search Results',
    properties: 'Properties',
    propertiesFound: 'properties found',
    sortBy: 'Sort By',
    relevance: 'Relevance',
    priceLowHigh: 'Price: Low to High',
    priceHighLow: 'Price: High to Low',
    newestFirst: 'Newest First',
    oldestFirst: 'Oldest First',
    filters: 'Filters',
    clearFilters: 'Clear Filters',
    saveSearch: 'Save Search',
    savedSearches: 'Saved Searches',
    compareSelected: 'Compare Selected',
    beds: 'Beds',
    baths: 'Baths',
    propertyType: 'Property Type',
    minPrice: 'Min Price',
    maxPrice: 'Max Price',
    forSale: 'For Sale',
    forRent: 'For Rent',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    fullName: 'Full Name',
    forgotPassword: 'Forgot Password?',
    alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: "Don\'t have an account?",
    createAccount: 'Create Account',
    welcomeBack: 'Welcome Back',
    signInToContinue: 'Sign in to continue',
    createYourAccount: 'Create Your Account',
    joinListingLens: 'Join ListingLens today',
    dashboard: 'Dashboard',
    myAnalyses: 'My Analyses',
    recentActivity: 'Recent Activity',
    analyseProperty: 'Analyse Property',
    newAnalysis: 'New Analysis',
    viewAnalysis: 'View Analysis',
    welcomeBack2: 'Welcome back',
    dashboardSubtitle: 'Analyze property listings and get AI-powered insights for smarter buying decisions',
    analyzePropertyListing: 'Analyze Property Listing',
    analyzePropertyDesc: 'Paste a listing URL, upload a screenshot, or enter property details manually for AI-powered analysis',
    pasteURL: 'Paste URL',
    uploadScreenshot: 'Upload Screenshot',
    enterDetails: 'Enter Details',
    propertyListingURL: 'Property Listing URL',
    urlDescription: 'Enter a valid Domain.com.au or Realestate.com.au listing URL',
    analyzeProperty: 'Analyze Property',
    analyzing: 'Analyzing...',
    dragDropScreenshot: 'Drag and drop your screenshot here',
    orClickBrowse: 'or click to browse files',
    removeFile: 'Remove File',
    recentAnalyses: 'Recent Analyses',
    propertiesAnalyzed: 'properties analyzed',
    propertyAnalyzed: 'property analyzed',
    searchByAddress: 'Search by address, suburb, or verdict...',
    sortByLabel: 'Sort by...',
    date: 'Date',
    address: 'Address',
    suburb: 'Suburb',
    verdict: 'Verdict',
    confidence: 'Confidence',
    viewDetails: 'View Details',
    source: 'Source',
    noAnalysesYet: 'No analyses yet',
    startFirstAnalysis: 'Start your first analysis',
    preparingResults: 'Preparing analysis results...',
    propertyAddress: 'Property Address',
    propertyAddressPlaceholder: 'e.g. 42 Harbour Street, Sydney NSW 2000',
    askingPrice: 'Asking Price',
    askingPricePlaceholder: 'e.g. $850,000 or AED 2,500,000',
    bedrooms: 'Bedrooms',
    bathrooms: 'Bathrooms',
    region: 'Region',
    propertyDescription: 'Property Description',
    propertyDescriptionPlaceholder: 'Paste the property description from the listing (optional but improves analysis accuracy)',
    contactTitle: 'Contact Us',
    contactSubtitle: "We\'d love to hear from you",
    name: 'Name',
    phone: 'Phone',
    subject: 'Subject',
    message: 'Message',
    sendMessage: 'Send Message',
    messageSent: 'Message sent successfully!',
    generalEnquiry: 'General Enquiry',
    technicalIssue: 'Technical Issue',
    billingSupport: 'Billing & Subscriptions',
    aboutTitle: 'About ListingLens',
    ourStory: 'Our Story',
    ourMission: 'Our Mission',
    ourValues: 'Our Values',
    ourTeam: 'Our Team',
    faqTitle: 'Frequently Asked Questions',
    faqSubtitle: 'Find answers to common questions',
    searchFAQ: 'Search FAQs...',
    professionals: 'Professionals',
    allProfessionals: 'All Professionals',
    bookConsultation: 'Book Consultation',
    viewProfile: 'View Profile',
    verified: 'Verified',
    rating: 'Rating',
    reviews: 'Reviews',
    findProfessionals: 'Find Professionals',
    findRightProfessional: 'Find the Right Professional',
    findProfessionalDesc: 'Connect with verified lawyers, photographers, and stylists to make your property journey seamless.',
    verifiedProfessionals: 'Verified Professionals',
    showingProfessionals: 'Showing',
    noProfessionalsFound: 'No professionals found',
    adjustFilters: 'Try adjusting your filters or search query',
    joinAsProfessional: 'Join as Professional',
    searchByNameSpec: 'Search by name, specialization...',
    topRated: 'Top Rated',
    mostReviews: 'Most Reviews',
    startingFrom: 'Starting from',
    propertyDetails: 'Property Details',
    aiAnalysis: 'AI Analysis',
    contactAgent: 'Contact Agent',
    bookInspection: 'Book Inspection',
    shareProperty: 'Share Property',
    saveProperty: 'Save Property',
    priceGuide: 'Price Guide',
    footerTagline: 'AI-powered property intelligence for smarter real estate decisions.',
    quickLinks: 'Quick Links',
    legalInfo: 'Legal',
    followUs: 'Follow Us',
    allRightsReserved: 'All rights reserved.',
    howItWorksTitle: 'How It Works',
    howItWorksSubtitle: 'Three simple steps to smarter property decisions',
    step1Title: 'Enter Property Details',
    step1Desc: 'Paste a listing URL or enter property details manually',
    step2Title: 'AI Analyses the Market',
    step2Desc: 'Our AI compares thousands of data points in seconds',
    step3Title: 'Get Actionable Insights',
    step3Desc: 'Receive fair price estimates, risk flags, and negotiation tips',
    featuresTitle: 'Powerful Features',
    featuresSubtitle: 'Everything you need to make smarter property decisions',
    agentDashboardTitle: 'Agent Dashboard',
    myListings: 'My Listings',
    createListing: 'Create Listing',
    bulkUpload: 'Bulk Upload',
    totalListings: 'Total Listings',
    activeListings: 'Active Listings',
    totalViews: 'Total Views',
    totalLeads: 'Total Leads',
    activeLive: 'Active / Live',
    leadsGenerated: 'Leads Generated',
    monthlyViews: 'Monthly Views',
    manageListings: 'Manage your listings',
    quickList: 'Quick List',
    addListing: 'Add Listing',
    allListings: 'All Listings',
    searchAddress: 'Search address...',
    property: 'Property',
    status: 'Status',
    created: 'Created',
    views: 'Views',
    leads: 'Leads',
    actions: 'Actions',
    noListingsFound: 'No listings found.',
    publishLive: 'Publish Live',
    moveToDraft: 'Move to Draft',
    markAsSold: 'Mark as Sold',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    selected: 'selected',
    markAs: 'Mark as',
    swipeToNavigate: '← Swipe to navigate →',
    ofListings: 'of',
    listings: 'listings',
    complete: 'complete',
    quickListTitle: 'Quick List',
    quickListDesc: 'Essential fields only — get listed fast',
    propertyAddressRequired: 'Property Address *',
    askingPriceRequired: 'Asking Price *',
    shortDescription: 'Short Description',
    shortDescriptionOptional: 'Short Description (optional)',
    saveAsDraft: 'Save as Draft',
    publishing: 'Publishing...',
    draftNote: 'You can save as draft and return later to add photos, pricing analysis, and AI-enhanced copy.',
    bulkUploadTitle: 'Bulk Upload Properties',
    bulkUploadDesc: 'Import multiple listings at once via CSV or manual entry',
    csvUpload: 'CSV Upload',
    manualEntry: 'Manual Entry',
    dropCSVHere: 'Drop CSV file here or click to browse',
    supportsCSV: 'Supports .csv and .txt files',
    orPasteCSV: 'Or paste CSV content',
    loadSample: 'Load sample',
    propertiesReadyToImport: 'properties ready to import',
    addAnotherProperty: 'Add another property',
    importProperties: 'Import',
    importing: 'Importing...',
    createYourListing: 'Create Your Listing',
    createListingDesc: 'Follow the steps to create a professional property listing',
    stepRoleAddress: 'Role & Address',
    stepPropertyBasics: 'Property Basics',
    stepUploadPhotos: 'Upload Photos',
    stepTellStory: 'Tell Your Story',
    stepGenerateCopy: 'Generate Copy',
    stepPriceGuidance: 'Price Guidance',
    stepProfessionalServices: 'Professional Services',
    stepReviewPublish: 'Review & Publish',
    letsGetStarted: "Let\'s Get Started",
    letsGetStartedDesc: 'Tell us about yourself and the property',
    iAmA: 'I am a',
    owner: 'Owner',
    agent: 'Agent',
    developer: 'Developer',
    selectRole: 'Please select your role',
    state: 'State',
    postcode: 'Postcode',
    selectState: 'Select state',
    continue: 'Continue',
    propertyDetailsTitle: 'Property Details',
    propertyDetailsDesc: 'Tell us about the property features',
    house: 'House',
    unitApartment: 'Unit/Apartment',
    listingType: 'Listing Type',
    forSaleLabel: 'For Sale',
    forRentLabel: 'For Rent',
    commercialLabel: 'Commercial',
    offMarketLabel: 'Off-Market',
    parkingSpaces: 'Parking Spaces',
    uploadPhotosTitle: 'Upload Photos',
    uploadPhotosDesc: 'Add high-quality photos of your property',
    clickToUpload: 'Click to upload photos',
    dragAndDrop: 'or drag and drop',
    pngJpgLimit: 'PNG, JPG up to 10MB each',
    photosUploaded: 'photo(s) uploaded',
    aiEnhancementAvailable: 'AI enhancement available',
    tellYourStoryTitle: 'Tell Your Story',
    tellYourStoryDesc: 'Help us create compelling copy for your listing',
    whatYouLoveLabel: 'What do you love most about this property?',
    whatYouLovePlaceholder: 'The harbour views, the spacious kitchen, the quiet neighborhood...',
    renovationsLabel: 'What renovations or improvements have been made?',
    renovationsPlaceholder: 'New kitchen in 2023, fresh paint throughout, updated bathrooms...',
    idealBuyerLabel: 'Who is the ideal buyer or tenant for this property?',
    idealBuyerPlaceholder: 'Young families, professionals, downsizers...',
    generateCopyTitle: 'Generate Listing Copy',
    generateCopyDesc: 'AI-powered content crafted from your property details and story',
    readyToGenerate: 'Ready to Generate',
    readyToGenerateDesc: 'Our AI will craft compelling headlines, a punchy short description, and a full listing description based on your property details and story.',
    generateCopyWithAI: 'Generate Copy with AI',
    generatingCopy: 'Generating Copy...',
    chooseHeadline: 'Choose a Headline',
    selectPreferredHeadline: 'Select your preferred headline',
    shortDescriptionLabel: 'Short Description',
    shortDescriptionHint: 'Perfect for listing portals and social media (50-75 words)',
    fullDescriptionLabel: 'Full Description',
    fullDescriptionHint: 'Detailed description for attracting buyers (180-220 words)',
    regenerate: 'Regenerate',
    priceGuidanceTitle: 'Price Guidance',
    priceGuidanceDesc: 'Set your asking price with AI-powered insights',
    getPriceGuidance: 'Get Price Guidance',
    getPriceGuidanceDesc: 'Based on comparable sales and market analysis',
    showPriceGuidance: 'Show Price Guidance',
    suggestedPriceRange: 'Suggested Price Range',
    confidenceBasedOnMarket: 'confidence based on market data',
    weeklyRent: 'Weekly Rent',
    professionalServicesTitle: 'Professional Services',
    professionalServicesDesc: 'Optional services to enhance your listing (skip if not needed)',
    professionalPhotography: 'Professional Photography',
    photographyDesc: 'High-quality photos that showcase your property',
    propertyStyling: 'Property Styling',
    stylingDesc: 'Expert staging to maximize appeal',
    legalServices: 'Legal Services',
    legalServicesDesc: 'Contract preparation and legal advice',
    premiumMarketing: 'Premium Marketing',
    marketingDesc: 'Featured listings and social media promotion',
    totalAdditionalServices: 'Total Additional Services:',
    reviewPublishTitle: 'Review & Publish',
    reviewPublishDesc: 'Check everything looks good before publishing',
    propertyDetailsSection: 'Property Details',
    type: 'Type',
    parking: 'Parking',
    price: 'Price',
    listingCopy: 'Listing Copy',
    headline: 'Headline',
    fullDescription: 'Full Description',
    professionalServicesSection: 'Professional Services',
    publishListing: 'Publish Listing',
    carSpaces: 'Car Spaces',
    landSize: 'Land Size',
    propertySize: 'Property Size',
    yearBuilt: 'Year Built',
    inspectionTimes: 'Inspection Times',
    askQuestion: 'Ask a Question',
    backToSearch: 'Back to Search',
    previousProperty: 'Previous Property',
    nextProperty: 'Next Property',
    previous: 'Previous',
    next2: 'Next',
    contactForPrice: 'Contact for price',
    perWeek: '/ week',
    perYear: '/ year',
    callAgent: 'Call Agent',
    availableSevenDays: 'Available 7 days',
    backToDashboard: 'Back to Dashboard',
    propertyAnalysisReport: 'Property Analysis Report',
    aiGenerated: 'AI Generated',
    analysisId: 'Analysis ID',
    downloadPDFReport: 'Download PDF Report',
    generatingPDF: 'Generating PDF...',
    shareAnalysis: 'Share Analysis',
    tosTitle: 'Terms of Service',
    tosLegalDoc: 'Legal Document',
    tosIntro: 'Please read these Terms of Service carefully before using ListingLens.',
    tosTableOfContents: 'Table of Contents',
    tosQuestionsTitle: 'Questions about these Terms?',
    tosContactLegal: 'Contact Legal Team',
    tosLastUpdated: 'Last updated',
    privacyTitle: 'Privacy Policy',
    privacyLegalDoc: 'Legal Document',
    privacyIntro: 'ListingLens is committed to protecting your privacy.',
    privacyTableOfContents: 'Table of Contents',
    privacyQuestionsTitle: 'Questions about this Privacy Policy?',
    privacyContactOfficer: 'Contact Our Privacy Officer',
    founderCEO: 'Founder & CEO',
    missionVision: 'Mission & Vision',
    ourMissionText: 'To democratise property intelligence by providing every buyer, seller, and investor with AI-powered analysis, real-time market data, and access to verified professionals.',
    ourVisionText: "To become the world's most trusted property intelligence platform, where every real estate decision is backed by data, AI insights, and a community of verified professionals.",
    ourJourney: 'Our Journey',
    whatMakesUsUnique: 'What Makes Us Unique',
    readyToMakeSmarter: 'Ready to Make Smarter Property Decisions?',
    joinThousands: 'Join thousands of buyers, sellers, and investors who trust ListingLens.',
    getStartedFree: 'Get Started Free',
    propertiesAnalysed: 'Properties Analysed',
    australianStatesCovered: 'Australian States Covered',
    uaeEmiratesCovered: 'UAE Emirates Covered',
    verifiedProfessionalsCount: 'Verified Professionals',
    contactInformation: 'Contact Information',
    quickHelp: 'Quick Help',
    sendUsMessage: 'Send Us a Message',
    messageSentTitle: 'Message Sent!',
    messageSentDesc: "Thank you for reaching out. We\'ll get back to you within 1 business day.",
    sendAnotherMessage: 'Send Another Message',
    sending: 'Sending...',
    optional: 'Optional',
    selectSubject: 'Select a subject',
    tellUsHowHelp: 'Tell us how we can help...',
    fillAllRequired: 'Please fill in all required fields.',
    yourFullName: 'Your full name',
    browseHelp: 'Browse Help Guides',
    howCanWeHelp: 'How Can We Help?',
    noQuestionsFound: 'No questions found',
    tryDifferentSearch: 'Try a different search term or browse all categories',
    clearFiltersBtn: 'Clear filters',
    stillHaveQuestions: 'Still have questions?',
    cantFindAnswer: 'Can\'t find what you\'re looking for? Our support team is here to help.',
    helpSupportTitle: 'Help & Support',
    helpSupportSubtitle: 'Step-by-step guides tailored to your role. Select who you are to get started.',
    buyer: 'Buyer',
    seller: 'Seller',
    professional: 'Professional',
    commonTroubleshooting: 'Common Troubleshooting',
    helpCenter: 'Help Center',
    australia: 'Australia',
    uae: 'UAE',
    bangladesh: 'Bangladesh',
    logout: 'Logout',
    settings: 'Settings',
    profile: 'Profile',
    notifications: 'Notifications',
    goBack: 'Go Back',
    readMore: 'Read More',
    showLess: 'Show Less',
    seeAll: 'See All',
    noData: 'No data available',
    error: 'An error occurred',
    tryAgain: 'Try Again',
  },
  bn: {
    login: 'লগইন',
    getStarted: 'শুরু করুন',
    more: 'আরও',
    howItWorks: 'কীভাবে কাজ করে',
    features: 'বৈশিষ্ট্য',
    listProperty: 'সম্পত্তি তালিকা',
    agentDashboard: 'এজেন্ট ড্যাশবোর্ড',
    lawyers: 'আইনজীবী',
    photographers: 'ফটোগ্রাফার',
    stylists: 'স্টাইলিস্ট',
    heroTitle: 'এআই-চালিত সম্পত্তি বিশ্লেষণ',
    heroSubtitle: 'স্মার্ট তালিকা, সেরা সিদ্ধান্ত — অস্ট্রেলিয়া, UAE ও বাংলাদেশের জন্য',
    searchPlaceholder: 'এলাকা, শহর বা পোস্টকোড খুঁজুন...',
    buy: 'কিনুন',
    rent: 'ভাড়া',
    sell: 'বিক্রি',
    commercial: 'বাণিজ্যিক',
    offMarket: 'অফ-মার্কেট',
    bangladeshTitle: 'বাংলাদেশ সম্পত্তি বাজার',
    bangladeshSubtitle: 'ঢাকা, চট্টগ্রাম, সিলেট ও কক্সবাজারে এআই-চালিত অন্তর্দৃষ্টি',
    rajukNote: 'রাজউক অনুমোদিত উন্নয়ন',
    language: 'ভাষা',
    english: 'English',
    bengali: 'বাংলা',
    search: 'খুঁজুন',
    filter: 'ফিল্টার',
    sort: 'সাজান',
    apply: 'প্রয়োগ করুন',
    cancel: 'বাতিল',
    save: 'সংরক্ষণ',
    submit: 'জমা দিন',
    back: 'পিছনে',
    next: 'পরবর্তী',
    close: 'বন্ধ করুন',
    loading: 'লোড হচ্ছে...',
    noResults: 'কোনো ফলাফল পাওয়া যায়নি',
    viewAll: 'সব দেখুন',
    learnMore: 'আরও জানুন',
    contactUs: 'যোগাযোগ করুন',
    home: 'হোম',
    aboutUs: 'আমাদের সম্পর্কে',
    faq: 'সাধারণ প্রশ্নাবলী',
    helpSupport: 'সহায়তা',
    termsOfService: 'সেবার শর্তাবলী',
    privacyPolicy: 'গোপনীয়তা নীতি',
    searchResults: 'অনুসন্ধান ফলাফল',
    properties: 'সম্পত্তি',
    propertiesFound: 'টি সম্পত্তি পাওয়া গেছে',
    sortBy: 'সাজানোর ক্রম',
    relevance: 'প্রাসঙ্গিকতা',
    priceLowHigh: 'মূল্য: কম থেকে বেশি',
    priceHighLow: 'মূল্য: বেশি থেকে কম',
    newestFirst: 'সর্বশেষ প্রথমে',
    oldestFirst: 'পুরনো প্রথমে',
    filters: 'ফিল্টার',
    clearFilters: 'ফিল্টার মুছুন',
    saveSearch: 'অনুসন্ধান সংরক্ষণ',
    savedSearches: 'সংরক্ষিত অনুসন্ধান',
    compareSelected: 'তুলনা করুন',
    beds: 'শয়নকক্ষ',
    baths: 'বাথরুম',
    propertyType: 'সম্পত্তির ধরন',
    minPrice: 'সর্বনিম্ন মূল্য',
    maxPrice: 'সর্বোচ্চ মূল্য',
    forSale: 'বিক্রয়ের জন্য',
    forRent: 'ভাড়ার জন্য',
    signIn: 'সাইন ইন',
    signUp: 'নিবন্ধন',
    email: 'ইমেইল',
    password: 'পাসওয়ার্ড',
    confirmPassword: 'পাসওয়ার্ড নিশ্চিত করুন',
    fullName: 'পূর্ণ নাম',
    forgotPassword: 'পাসওয়ার্ড ভুলে গেছেন?',
    alreadyHaveAccount: 'ইতিমধ্যে অ্যাকাউন্ট আছে?',
    dontHaveAccount: 'অ্যাকাউন্ট নেই?',
    createAccount: 'অ্যাকাউন্ট তৈরি করুন',
    welcomeBack: 'স্বাগতম',
    signInToContinue: 'চালিয়ে যেতে সাইন ইন করুন',
    createYourAccount: 'আপনার অ্যাকাউন্ট তৈরি করুন',
    joinListingLens: 'আজই ListingLens-এ যোগ দিন',
    dashboard: 'ড্যাশবোর্ড',
    myAnalyses: 'আমার বিশ্লেষণ',
    recentActivity: 'সাম্প্রতিক কার্যক্রম',
    analyseProperty: 'সম্পত্তি বিশ্লেষণ',
    newAnalysis: 'নতুন বিশ্লেষণ',
    viewAnalysis: 'বিশ্লেষণ দেখুন',
    welcomeBack2: 'স্বাগত',
    dashboardSubtitle: 'সম্পত্তির তালিকা বিশ্লেষণ করুন এবং স্মার্ট ক্রয় সিদ্ধান্তের জন্য এআই-চালিত অন্তর্দৃষ্টি পান',
    analyzePropertyListing: 'সম্পত্তির তালিকা বিশ্লেষণ করুন',
    analyzePropertyDesc: 'এআই-চালিত বিশ্লেষণের জন্য একটি তালিকা URL পেস্ট করুন, স্ক্রিনশট আপলোড করুন বা ম্যানুয়ালি তথ্য দিন',
    pasteURL: 'URL পেস্ট করুন',
    uploadScreenshot: 'স্ক্রিনশট আপলোড',
    enterDetails: 'তথ্য দিন',
    propertyListingURL: 'সম্পত্তির তালিকা URL',
    urlDescription: 'একটি বৈধ Domain.com.au বা Realestate.com.au তালিকা URL দিন',
    analyzeProperty: 'সম্পত্তি বিশ্লেষণ করুন',
    analyzing: 'বিশ্লেষণ হচ্ছে...',
    dragDropScreenshot: 'এখানে স্ক্রিনশট টেনে আনুন',
    orClickBrowse: 'বা ফাইল ব্রাউজ করতে ক্লিক করুন',
    removeFile: 'ফাইল সরান',
    recentAnalyses: 'সাম্প্রতিক বিশ্লেষণ',
    propertiesAnalyzed: 'টি সম্পত্তি বিশ্লেষণ করা হয়েছে',
    propertyAnalyzed: 'টি সম্পত্তি বিশ্লেষণ করা হয়েছে',
    searchByAddress: 'ঠিকানা, এলাকা বা রায় দিয়ে খুঁজুন...',
    sortByLabel: 'সাজান...',
    date: 'তারিখ',
    address: 'ঠিকানা',
    suburb: 'এলাকা',
    verdict: 'রায়',
    confidence: 'আস্থা',
    viewDetails: 'বিস্তারিত দেখুন',
    source: 'উৎস',
    noAnalysesYet: 'এখনো কোনো বিশ্লেষণ নেই',
    startFirstAnalysis: 'প্রথম বিশ্লেষণ শুরু করুন',
    preparingResults: 'বিশ্লেষণের ফলাফল প্রস্তুত হচ্ছে...',
    propertyAddress: 'সম্পত্তির ঠিকানা',
    propertyAddressPlaceholder: 'যেমন: ৪২ হারবার স্ট্রিট, সিডনি NSW 2000',
    askingPrice: 'চাওয়া মূল্য',
    askingPricePlaceholder: 'যেমন: $850,000 বা AED 2,500,000',
    bedrooms: 'শয়নকক্ষ',
    bathrooms: 'বাথরুম',
    region: 'অঞ্চল',
    propertyDescription: 'সম্পত্তির বিবরণ',
    propertyDescriptionPlaceholder: 'তালিকা থেকে সম্পত্তির বিবরণ পেস্ট করুন (ঐচ্ছিক কিন্তু বিশ্লেষণের নির্ভুলতা বাড়ায়)',
    contactTitle: 'যোগাযোগ করুন',
    contactSubtitle: 'আমরা আপনার কথা শুনতে চাই',
    name: 'নাম',
    phone: 'ফোন',
    subject: 'বিষয়',
    message: 'বার্তা',
    sendMessage: 'বার্তা পাঠান',
    messageSent: 'বার্তা সফলভাবে পাঠানো হয়েছে!',
    generalEnquiry: 'সাধারণ জিজ্ঞাসা',
    technicalIssue: 'প্রযুক্তিগত সমস্যা',
    billingSupport: 'বিলিং ও সাবস্ক্রিপশন',
    aboutTitle: 'ListingLens সম্পর্কে',
    ourStory: 'আমাদের গল্প',
    ourMission: 'আমাদের লক্ষ্য',
    ourValues: 'আমাদের মূল্যবোধ',
    ourTeam: 'আমাদের দল',
    faqTitle: 'সাধারণ জিজ্ঞাসা',
    faqSubtitle: 'সাধারণ প্রশ্নের উত্তর খুঁজুন',
    searchFAQ: 'প্রশ্ন খুঁজুন...',
    professionals: 'পেশাদার',
    allProfessionals: 'সকল পেশাদার',
    bookConsultation: 'পরামর্শ বুক করুন',
    viewProfile: 'প্রোফাইল দেখুন',
    verified: 'যাচাইকৃত',
    rating: 'রেটিং',
    reviews: 'পর্যালোচনা',
    findProfessionals: 'পেশাদার খুঁজুন',
    findRightProfessional: 'সঠিক পেশাদার খুঁজুন',
    findProfessionalDesc: 'আপনার সম্পত্তির যাত্রা সহজ করতে যাচাইকৃত আইনজীবী, ফটোগ্রাফার এবং স্টাইলিস্টদের সাথে সংযুক্ত হন।',
    verifiedProfessionals: 'যাচাইকৃত পেশাদার',
    showingProfessionals: 'দেখানো হচ্ছে',
    noProfessionalsFound: 'কোনো পেশাদার পাওয়া যায়নি',
    adjustFilters: 'ফিল্টার বা অনুসন্ধান পরিবর্তন করে দেখুন',
    joinAsProfessional: 'পেশাদার হিসেবে যোগ দিন',
    searchByNameSpec: 'নাম, বিশেষত্ব দিয়ে খুঁজুন...',
    topRated: 'সর্বোচ্চ রেটিং',
    mostReviews: 'সর্বাধিক পর্যালোচনা',
    startingFrom: 'শুরু থেকে',
    propertyDetails: 'সম্পত্তির বিবরণ',
    aiAnalysis: 'এআই বিশ্লেষণ',
    contactAgent: 'এজেন্টের সাথে যোগাযোগ',
    bookInspection: 'পরিদর্শন বুক করুন',
    shareProperty: 'শেয়ার করুন',
    saveProperty: 'সংরক্ষণ করুন',
    priceGuide: 'মূল্য নির্দেশিকা',
    footerTagline: 'স্মার্ট রিয়েল এস্টেট সিদ্ধান্তের জন্য এআই-চালিত সম্পত্তি বিশ্লেষণ।',
    quickLinks: 'দ্রুত লিঙ্ক',
    legalInfo: 'আইনি তথ্য',
    followUs: 'আমাদের অনুসরণ করুন',
    allRightsReserved: 'সর্বস্বত্ব সংরক্ষিত।',
    howItWorksTitle: 'কীভাবে কাজ করে',
    howItWorksSubtitle: 'স্মার্ট সম্পত্তি সিদ্ধান্তের জন্য তিনটি সহজ ধাপ',
    step1Title: 'সম্পত্তির তথ্য দিন',
    step1Desc: 'একটি লিস্টিং URL পেস্ট করুন বা ম্যানুয়ালি তথ্য দিন',
    step2Title: 'এআই বাজার বিশ্লেষণ করে',
    step2Desc: 'আমাদের এআই সেকেন্ডে হাজার হাজার ডেটা পয়েন্ট তুলনা করে',
    step3Title: 'কার্যকর অন্তর্দৃষ্টি পান',
    step3Desc: 'ন্যায্য মূল্য অনুমান, ঝুঁকির সংকেত এবং আলোচনার টিপস পান',
    featuresTitle: 'শক্তিশালী বৈশিষ্ট্য',
    featuresSubtitle: 'স্মার্ট সম্পত্তি সিদ্ধান্তের জন্য সবকিছু',
    agentDashboardTitle: 'এজেন্ট ড্যাশবোর্ড',
    myListings: 'আমার তালিকা',
    createListing: 'তালিকা তৈরি করুন',
    bulkUpload: 'বাল্ক আপলোড',
    totalListings: 'মোট তালিকা',
    activeListings: 'সক্রিয় তালিকা',
    totalViews: 'মোট ভিউ',
    totalLeads: 'মোট লিড',
    activeLive: 'সক্রিয় / লাইভ',
    leadsGenerated: 'লিড তৈরি হয়েছে',
    monthlyViews: 'মাসিক ভিউ',
    manageListings: 'আপনার তালিকা পরিচালনা করুন',
    quickList: 'দ্রুত তালিকা',
    addListing: 'তালিকা যোগ করুন',
    allListings: 'সব তালিকা',
    searchAddress: 'ঠিকানা খুঁজুন...',
    property: 'সম্পত্তি',
    status: 'অবস্থা',
    created: 'তৈরির তারিখ',
    views: 'ভিউ',
    leads: 'লিড',
    actions: 'কার্যক্রম',
    noListingsFound: 'কোনো তালিকা পাওয়া যায়নি।',
    publishLive: 'লাইভ প্রকাশ করুন',
    moveToDraft: 'ড্রাফটে নিন',
    markAsSold: 'বিক্রিত হিসেবে চিহ্নিত করুন',
    delete: 'মুছুন',
    edit: 'সম্পাদনা',
    view: 'দেখুন',
    selected: 'টি নির্বাচিত',
    markAs: 'হিসেবে চিহ্নিত করুন',
    swipeToNavigate: '← সোয়াইপ করে নেভিগেট করুন →',
    ofListings: 'এর মধ্যে',
    listings: 'টি তালিকা',
    complete: '% সম্পন্ন',
    quickListTitle: 'দ্রুত তালিকা',
    quickListDesc: 'শুধু প্রয়োজনীয় তথ্য — দ্রুত তালিকাভুক্ত হন',
    propertyAddressRequired: 'সম্পত্তির ঠিকানা *',
    askingPriceRequired: 'চাওয়া মূল্য *',
    shortDescription: 'সংক্ষিপ্ত বিবরণ',
    shortDescriptionOptional: 'সংক্ষিপ্ত বিবরণ (ঐচ্ছিক)',
    saveAsDraft: 'ড্রাফট হিসেবে সংরক্ষণ',
    publishing: 'প্রকাশ হচ্ছে...',
    draftNote: 'আপনি ড্রাফট হিসেবে সংরক্ষণ করতে পারেন এবং পরে ফটো, মূল্য বিশ্লেষণ এবং এআই-উন্নত কপি যোগ করতে ফিরে আসতে পারেন।',
    bulkUploadTitle: 'বাল্ক সম্পত্তি আপলোড',
    bulkUploadDesc: 'CSV বা ম্যানুয়াল এন্ট্রির মাধ্যমে একসাথে একাধিক তালিকা আমদানি করুন',
    csvUpload: 'CSV আপলোড',
    manualEntry: 'ম্যানুয়াল এন্ট্রি',
    dropCSVHere: 'CSV ফাইল এখানে ড্রপ করুন বা ব্রাউজ করতে ক্লিক করুন',
    supportsCSV: '.csv এবং .txt ফাইল সমর্থিত',
    orPasteCSV: 'বা CSV কন্টেন্ট পেস্ট করুন',
    loadSample: 'নমুনা লোড করুন',
    propertiesReadyToImport: 'টি সম্পত্তি আমদানির জন্য প্রস্তুত',
    addAnotherProperty: 'আরেকটি সম্পত্তি যোগ করুন',
    importProperties: 'আমদানি করুন',
    importing: 'আমদানি হচ্ছে...',
    createYourListing: 'আপনার তালিকা তৈরি করুন',
    createListingDesc: 'একটি পেশাদার সম্পত্তি তালিকা তৈরি করতে ধাপগুলো অনুসরণ করুন',
    stepRoleAddress: 'ভূমিকা ও ঠিকানা',
    stepPropertyBasics: 'সম্পত্তির মূল তথ্য',
    stepUploadPhotos: 'ফটো আপলোড',
    stepTellStory: 'আপনার গল্প বলুন',
    stepGenerateCopy: 'কপি তৈরি করুন',
    stepPriceGuidance: 'মূল্য নির্দেশিকা',
    stepProfessionalServices: 'পেশাদার সেবা',
    stepReviewPublish: 'পর্যালোচনা ও প্রকাশ',
    letsGetStarted: 'শুরু করা যাক',
    letsGetStartedDesc: 'আপনার এবং সম্পত্তি সম্পর্কে আমাদের জানান',
    iAmA: 'আমি একজন',
    owner: 'মালিক',
    agent: 'এজেন্ট',
    developer: 'ডেভেলপার',
    selectRole: 'অনুগ্রহ করে আপনার ভূমিকা নির্বাচন করুন',
    state: 'রাজ্য',
    postcode: 'পোস্টকোড',
    selectState: 'রাজ্য নির্বাচন করুন',
    continue: 'চালিয়ে যান',
    propertyDetailsTitle: 'সম্পত্তির বিবরণ',
    propertyDetailsDesc: 'সম্পত্তির বৈশিষ্ট্য সম্পর্কে জানান',
    house: 'বাড়ি',
    unitApartment: 'ইউনিট/অ্যাপার্টমেন্ট',
    listingType: 'তালিকার ধরন',
    forSaleLabel: 'বিক্রয়ের জন্য',
    forRentLabel: 'ভাড়ার জন্য',
    commercialLabel: 'বাণিজ্যিক',
    offMarketLabel: 'অফ-মার্কেট',
    parkingSpaces: 'পার্কিং স্থান',
    uploadPhotosTitle: 'ফটো আপলোড করুন',
    uploadPhotosDesc: 'আপনার সম্পত্তির উচ্চমানের ফটো যোগ করুন',
    clickToUpload: 'ফটো আপলোড করতে ক্লিক করুন',
    dragAndDrop: 'বা টেনে আনুন',
    pngJpgLimit: 'PNG, JPG সর্বোচ্চ ১০MB প্রতিটি',
    photosUploaded: 'টি ফটো আপলোড হয়েছে',
    aiEnhancementAvailable: 'এআই উন্নতি উপলব্ধ',
    tellYourStoryTitle: 'আপনার গল্প বলুন',
    tellYourStoryDesc: 'আপনার তালিকার জন্য আকর্ষণীয় কপি তৈরি করতে আমাদের সাহায্য করুন',
    whatYouLoveLabel: 'এই সম্পত্তি সম্পর্কে আপনি সবচেয়ে কী পছন্দ করেন?',
    whatYouLovePlaceholder: 'বন্দরের দৃশ্য, প্রশস্ত রান্নাঘর, শান্ত পাড়া...',
    renovationsLabel: 'কী কী সংস্কার বা উন্নতি করা হয়েছে?',
    renovationsPlaceholder: '২০২৩ সালে নতুন রান্নাঘর, সর্বত্র তাজা রং, আপডেট বাথরুম...',
    idealBuyerLabel: 'এই সম্পত্তির আদর্শ ক্রেতা বা ভাড়াটে কে?',
    idealBuyerPlaceholder: 'তরুণ পরিবার, পেশাদার, ডাউনসাইজার...',
    generateCopyTitle: 'তালিকার কপি তৈরি করুন',
    generateCopyDesc: 'আপনার সম্পত্তির বিবরণ ও গল্প থেকে এআই-চালিত কন্টেন্ট',
    readyToGenerate: 'তৈরির জন্য প্রস্তুত',
    readyToGenerateDesc: 'আমাদের এআই আপনার সম্পত্তির বিবরণ ও গল্পের উপর ভিত্তি করে আকর্ষণীয় শিরোনাম, সংক্ষিপ্ত বিবরণ এবং পূর্ণ তালিকার বিবরণ তৈরি করবে।',
    generateCopyWithAI: 'এআই দিয়ে কপি তৈরি করুন',
    generatingCopy: 'কপি তৈরি হচ্ছে...',
    chooseHeadline: 'একটি শিরোনাম বেছে নিন',
    selectPreferredHeadline: 'আপনার পছন্দের শিরোনাম নির্বাচন করুন',
    shortDescriptionLabel: 'সংক্ষিপ্ত বিবরণ',
    shortDescriptionHint: 'তালিকা পোর্টাল এবং সোশ্যাল মিডিয়ার জন্য উপযুক্ত (৫০-৭৫ শব্দ)',
    fullDescriptionLabel: 'পূর্ণ বিবরণ',
    fullDescriptionHint: 'ক্রেতাদের আকৃষ্ট করার জন্য বিস্তারিত বিবরণ (১৮০-২২০ শব্দ)',
    regenerate: 'পুনরায় তৈরি করুন',
    priceGuidanceTitle: 'মূল্য নির্দেশিকা',
    priceGuidanceDesc: 'এআই-চালিত অন্তর্দৃষ্টি দিয়ে আপনার চাওয়া মূল্য নির্ধারণ করুন',
    getPriceGuidance: 'মূল্য নির্দেশিকা পান',
    getPriceGuidanceDesc: 'তুলনামূলক বিক্রয় এবং বাজার বিশ্লেষণের উপর ভিত্তি করে',
    showPriceGuidance: 'মূল্য নির্দেশিকা দেখান',
    suggestedPriceRange: 'প্রস্তাবিত মূল্য পরিসীমা',
    confidenceBasedOnMarket: '% বাজার ডেটার উপর ভিত্তি করে আস্থা',
    weeklyRent: 'সাপ্তাহিক ভাড়া',
    professionalServicesTitle: 'পেশাদার সেবা',
    professionalServicesDesc: 'আপনার তালিকা উন্নত করতে ঐচ্ছিক সেবা (প্রয়োজন না হলে এড়িয়ে যান)',
    professionalPhotography: 'পেশাদার ফটোগ্রাফি',
    photographyDesc: 'আপনার সম্পত্তি প্রদর্শনের জন্য উচ্চমানের ফটো',
    propertyStyling: 'সম্পত্তি স্টাইলিং',
    stylingDesc: 'আকর্ষণ সর্বাধিক করতে বিশেষজ্ঞ স্টেজিং',
    legalServices: 'আইনি সেবা',
    legalServicesDesc: 'চুক্তি প্রস্তুতি এবং আইনি পরামর্শ',
    premiumMarketing: 'প্রিমিয়াম মার্কেটিং',
    marketingDesc: 'ফিচার্ড তালিকা এবং সোশ্যাল মিডিয়া প্রচার',
    totalAdditionalServices: 'মোট অতিরিক্ত সেবা:',
    reviewPublishTitle: 'পর্যালোচনা ও প্রকাশ',
    reviewPublishDesc: 'প্রকাশের আগে সব কিছু ঠিক আছে কিনা দেখুন',
    propertyDetailsSection: 'সম্পত্তির বিবরণ',
    type: 'ধরন',
    parking: 'পার্কিং',
    price: 'মূল্য',
    listingCopy: 'তালিকার কপি',
    headline: 'শিরোনাম',
    fullDescription: 'পূর্ণ বিবরণ',
    professionalServicesSection: 'পেশাদার সেবা',
    publishListing: 'তালিকা প্রকাশ করুন',
    carSpaces: 'গাড়ির জায়গা',
    landSize: 'জমির আকার',
    propertySize: 'সম্পত্তির আকার',
    yearBuilt: 'নির্মাণ সাল',
    inspectionTimes: 'পরিদর্শনের সময়',
    askQuestion: 'প্রশ্ন করুন',
    backToSearch: 'অনুসন্ধানে ফিরুন',
    previousProperty: 'আগের সম্পত্তি',
    nextProperty: 'পরের সম্পত্তি',
    previous: 'আগে',
    next2: 'পরে',
    contactForPrice: 'মূল্যের জন্য যোগাযোগ করুন',
    perWeek: '/ সপ্তাহ',
    perYear: '/ বছর',
    callAgent: 'এজেন্টকে কল করুন',
    availableSevenDays: '৭ দিন উপলব্ধ',
    backToDashboard: 'ড্যাশবোর্ডে ফিরুন',
    propertyAnalysisReport: 'সম্পত্তি বিশ্লেষণ প্রতিবেদন',
    aiGenerated: 'এআই তৈরি',
    analysisId: 'বিশ্লেষণ আইডি',
    downloadPDFReport: 'PDF প্রতিবেদন ডাউনলোড করুন',
    generatingPDF: 'PDF তৈরি হচ্ছে...',
    shareAnalysis: 'বিশ্লেষণ শেয়ার করুন',
    tosTitle: 'সেবার শর্তাবলী',
    tosLegalDoc: 'আইনি দলিল',
    tosIntro: 'ListingLens ব্যবহার করার আগে অনুগ্রহ করে সেবার শর্তাবলী মনোযোগ দিয়ে পড়ুন।',
    tosTableOfContents: 'বিষয়সূচি',
    tosQuestionsTitle: 'এই শর্তাবলী সম্পর্কে প্রশ্ন আছে?',
    tosContactLegal: 'আইনি দলে যোগাযোগ করুন',
    tosLastUpdated: 'সর্বশেষ আপডেট',
    privacyTitle: 'গোপনীয়তা নীতি',
    privacyLegalDoc: 'আইনি দলিল',
    privacyIntro: 'ListingLens আপনার গোপনীয়তা রক্ষায় প্রতিশ্রুতিবদ্ধ।',
    privacyTableOfContents: 'বিষয়সূচি',
    privacyQuestionsTitle: 'এই গোপনীয়তা নীতি সম্পর্কে প্রশ্ন আছে?',
    privacyContactOfficer: 'আমাদের গোপনীয়তা কর্মকর্তার সাথে যোগাযোগ করুন',
    founderCEO: 'প্রতিষ্ঠাতা ও সিইও',
    missionVision: 'লক্ষ্য ও দৃষ্টিভঙ্গি',
    ourMissionText: 'প্রতিটি ক্রেতা, বিক্রেতা এবং বিনিয়োগকারীকে এআই-চালিত বিশ্লেষণ, রিয়েল-টাইম বাজার ডেটা এবং যাচাইকৃত পেশাদারদের অ্যাক্সেস প্রদান করে সম্পত্তি বিশ্লেষণকে গণতান্ত্রিক করা।',
    ourVisionText: 'বিশ্বের সবচেয়ে বিশ্বস্ত সম্পত্তি বিশ্লেষণ প্ল্যাটফর্ম হওয়া, যেখানে প্রতিটি রিয়েল এস্টেট সিদ্ধান্ত ডেটা, এআই অন্তর্দৃষ্টি এবং যাচাইকৃত পেশাদারদের সম্প্রদায় দ্বারা সমর্থিত।',
    ourJourney: 'আমাদের যাত্রা',
    whatMakesUsUnique: 'আমাদের বিশেষত্ব',
    readyToMakeSmarter: 'স্মার্ট সম্পত্তি সিদ্ধান্ত নিতে প্রস্তুত?',
    joinThousands: 'হাজার হাজার ক্রেতা, বিক্রেতা এবং বিনিয়োগকারীদের সাথে যোগ দিন যারা ListingLens বিশ্বাস করেন।',
    getStartedFree: 'বিনামূল্যে শুরু করুন',
    propertiesAnalysed: 'সম্পত্তি বিশ্লেষণ করা হয়েছে',
    australianStatesCovered: 'অস্ট্রেলিয়ান রাজ্য কভার করা হয়েছে',
    uaeEmiratesCovered: 'UAE আমিরাত কভার করা হয়েছে',
    verifiedProfessionalsCount: 'যাচাইকৃত পেশাদার',
    contactInformation: 'যোগাযোগের তথ্য',
    quickHelp: 'দ্রুত সহায়তা',
    sendUsMessage: 'আমাদের একটি বার্তা পাঠান',
    messageSentTitle: 'বার্তা পাঠানো হয়েছে!',
    messageSentDesc: 'যোগাযোগ করার জন্য ধন্যবাদ। আমরা ১ কার্যদিবসের মধ্যে আপনার সাথে যোগাযোগ করব।',
    sendAnotherMessage: 'আরেকটি বার্তা পাঠান',
    sending: 'পাঠানো হচ্ছে...',
    optional: 'ঐচ্ছিক',
    selectSubject: 'একটি বিষয় নির্বাচন করুন',
    tellUsHowHelp: 'আমরা কীভাবে সাহায্য করতে পারি তা জানান...',
    fillAllRequired: 'অনুগ্রহ করে সব প্রয়োজনীয় তথ্য পূরণ করুন।',
    yourFullName: 'আপনার পূর্ণ নাম',
    browseHelp: 'সহায়তা গাইড দেখুন',
    howCanWeHelp: 'আমরা কীভাবে সাহায্য করতে পারি?',
    noQuestionsFound: 'কোনো প্রশ্ন পাওয়া যায়নি',
    tryDifferentSearch: 'ভিন্ন অনুসন্ধান শব্দ ব্যবহার করুন বা সব বিভাগ দেখুন',
    clearFiltersBtn: 'ফিল্টার মুছুন',
    stillHaveQuestions: 'এখনও প্রশ্ন আছে?',
    cantFindAnswer: 'খুঁজে পাচ্ছেন না? আমাদের সাপোর্ট টিম সাহায্য করতে প্রস্তুত।',
    helpSupportTitle: 'সহায়তা কেন্দ্র',
    helpSupportSubtitle: 'আপনার ভূমিকা অনুযায়ী ধাপে ধাপে গাইড। শুরু করতে আপনি কে তা নির্বাচন করুন।',
    buyer: 'ক্রেতা',
    seller: 'বিক্রেতা',
    professional: 'পেশাদার',
    commonTroubleshooting: 'সাধারণ সমস্যা সমাধান',
    helpCenter: 'সহায়তা কেন্দ্র',
    australia: 'অস্ট্রেলিয়া',
    uae: 'UAE',
    bangladesh: 'বাংলাদেশ',
    logout: 'লগআউট',
    settings: 'সেটিংস',
    profile: 'প্রোফাইল',
    notifications: 'বিজ্ঞপ্তি',
    goBack: 'ফিরে যান',
    readMore: 'আরও পড়ুন',
    showLess: 'কম দেখান',
    seeAll: 'সব দেখুন',
    noData: 'কোনো ডেটা নেই',
    error: 'একটি ত্রুটি ঘটেছে',
    tryAgain: 'আবার চেষ্টা করুন',
  }
};

const LanguageContext = createContext({
  language: 'en',
  setLanguage: () => {},
  t: (key) => key,
});

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');
  const t = React.useCallback((key) => translations?.[language]?.[key] || translations?.['en']?.[key] || key, [language]);
  const value = React.useMemo(() => ({ language, setLanguage, t }), [language, t]);
  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
export default LanguageContext;